/**
 * Avatar Component
 * User avatar with fallback to initials
 */

import React from 'react';
import { cn, getInitials } from '@/utils/helpers';

interface AvatarProps {
  name: string;
  src?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function Avatar({ name, src, size = 'md', className }: AvatarProps) {
  const sizes = {
    sm: 'h-6 w-6 text-xs',
    md: 'h-8 w-8 text-sm',
    lg: 'h-10 w-10 text-base',
  };

  return (
    <div
      className={cn(
        'rounded-full bg-primary-500 text-white flex items-center justify-center font-medium',
        sizes[size],
        className
      )}
    >
      {src ? (
        <img src={src} alt={name} className="rounded-full w-full h-full object-cover" />
      ) : (
        getInitials(name)
      )}
    </div>
  );
}
